import { render, staticRenderFns } from "./SinoForeignCooperation.vue?vue&type=template&id=fea7cc80&scoped=true"
import script from "./SinoForeignCooperation.vue?vue&type=script&lang=js"
export * from "./SinoForeignCooperation.vue?vue&type=script&lang=js"
import style0 from "./SinoForeignCooperation.vue?vue&type=style&index=0&id=fea7cc80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea7cc80",
  null
  
)

export default component.exports